import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '../../utils/cn';
import { Kbd } from '../Kbd/Kbd';

export const SearchInput = forwardRef(function SearchInput(
  { value, defaultValue, onChange, onClear, kbd, placeholder = 'Rechercher…', size = 'md', className, ...rest },
  ref
) {
  const SIZES = {
    sm: 'h-8  text-sm   pl-8  pr-2',
    md: 'h-9  text-sm   pl-9  pr-2',
    lg: 'h-10 text-base pl-10 pr-2',
  };

  const hasValue = (value ?? defaultValue ?? '').toString().length > 0;

  return (
    <div className={cn('relative inline-block w-full', className)}>
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute pointer-events-none" strokeWidth={1.8} />
      <input
        ref={ref}
        type="search"
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          'w-full bg-surface text-text placeholder:text-mute-2 outline-none rounded-md border border-border',
          'focus:bg-surface focus:border-ink focus:ring-2 focus:ring-ink/15 transition-colors duration-fast',
          SIZES[size],
          (kbd || onClear) && 'pr-16',
        )}
        {...rest}
      />
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {hasValue && onClear && (
          <button type="button" onClick={onClear} className="text-mute hover:text-text p-0.5 rounded" aria-label="Effacer">
            <X className="w-3.5 h-3.5" strokeWidth={2} />
          </button>
        )}
        {kbd && <Kbd size="sm">{kbd}</Kbd>}
      </div>
    </div>
  );
});

export default SearchInput;
